import React from 'react';
import styled from 'react-emotion';
import PropTypes from 'prop-types';
import CloseButton from './CloseButton';
import CoachInfos from '../CoachInfos';
import TabBar from './Tab';
import ActivitiesTabItem from './Tab/ActivitiesTabItem';
import DegreeTabItem from './Tab/DegreeTabItem';

const All = styled.div`
  display: ${props => (props.isOpen ? 'block' : 'none')};
`;

const Background = styled.div`
  position: fixed;
  height: 100%;
  width: 100%;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background: rgba(102, 117, 128, 0.85);
`;

const Container = styled.div`
  position: fixed;
  display: flex;
  flex-direction: column;
  height: 66vh;
  width: calc(100% - 20px);
  bottom: 0;
  left: 10px;
  right: 10px;
  background: #fff;
  border-radius: 4px 4px 0 0;
`;

const PhotoContainer = styled.div`
  display: flex;
  margin-right: auto;
  margin-left: auto;
  margin-top: -100px;
  padding: 4px;
  background: #fff;
`;

const Photo = styled.img`
  width: 200px;
  height: 200px;
  background-image: ${props => `url(${props.url})`};
  background-size: cover;
  background-position: center;
`;

const Header = styled.div`
  display: flex;
  justify-content: center;
`;

const CoachPanel = ({ coach, onClose, isOpen, activeTab, onChangeTab }) => (
  <All isOpen={isOpen}>
    <Background onClick={onClose} />
    <Container>
      <PhotoContainer>
        <Photo url={coach && coach.photo ? coach.photo : 'http://fakeimg.pl/200x200/'} />
      </PhotoContainer>

      <CloseButton onClick={onClose} />

      <Header>
        <CoachInfos coach={coach} align="center" margin="15px 0 0 0" />
      </Header>
      <TabBar onChangeTab={onChangeTab} activeTab={activeTab} />
      {activeTab === 'activities' ? <ActivitiesTabItem coach={coach} /> : <DegreeTabItem degrees={coach.degrees} />}
    </Container>
  </All>
);

CoachPanel.propTypes = {
  coach: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    surname: PropTypes.string.isRequired,
    activityIds: PropTypes.arrayOf(PropTypes.string).isRequired
  }),
  isOpen: PropTypes.bool.isRequired,
  activeTab: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  onChangeTab: PropTypes.func.isRequired
};

CoachPanel.defaultProps = {
  coach: undefined
};

export default CoachPanel;



// WEBPACK FOOTER //
// ./src/components/CoachPanel/CoachPanel.jsx